// Module
var code = "<a href=\"#\" data-bind=\"click: RunQuery\" class=\"runQuery-button\"> <i class=\"fa transition fa-play run-query-icon\"></i><span><!-- ko text: _labels.RUN_QUERY --><!-- /ko --></span> </a>";
// Exports
export default code;